import { useState, lazy, Suspense, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Header from '@/components/Header';
import HeroSection from '@/components/HeroSection';
import BreachShowcase from '@/components/BreachShowcase';
import ProtectionSection from '@/components/ProtectionSection';
import ClientsSection from '@/components/ClientsSection';
import ImpactSection from '@/components/ImpactSection';
import RequestFormDialog from '@/components/RequestFormDialog';

// Lazy load below-fold sections
const MethodologySection = lazy(() => import('@/components/MethodologySection'));
const TestimonialsSection = lazy(() => import('@/components/TestimonialsSection'));
const PreAuditSection = lazy(() => import('@/components/PreAuditSection'));
const ServicesSection = lazy(() => import('@/components/ServicesSection'));
const CostCalculator = lazy(() => import('@/components/CostCalculator'));
const FAQSection = lazy(() => import('@/components/FAQSection'));
const ContactSection = lazy(() => import('@/components/ContactSection'));
const Footer = lazy(() => import('@/components/Footer'));

const SectionFallback = () => (
  <div className="py-20 flex items-center justify-center">
    <div className="w-8 h-8 border-2 border-primary border-t-transparent rounded-full animate-spin" />
  </div>
);

const Security = () => {
  const [formOpen, setFormOpen] = useState(false);
  const location = useLocation();

  const openRequestForm = () => setFormOpen(true);

  useEffect(() => {
    if (location.hash) {
      setTimeout(() => {
        const el = document.querySelector(location.hash);
        el?.scrollIntoView({ behavior: 'smooth' });
      }, 300);
    }
  }, [location.hash]);

  return (
    <div className="min-h-screen bg-background text-foreground">
      <Header />
      <main>
        <HeroSection onRequestAudit={openRequestForm} />
        <BreachShowcase />
        <ProtectionSection onRequestAudit={openRequestForm} />
        <ClientsSection />
        <ImpactSection onRequestAudit={openRequestForm} />
        <Suspense fallback={<SectionFallback />}>
          <PreAuditSection />
        </Suspense>
        <Suspense fallback={<SectionFallback />}>
          <TestimonialsSection />
        </Suspense>
        <Suspense fallback={<SectionFallback />}>
          <CostCalculator />
        </Suspense>
        <Suspense fallback={<SectionFallback />}>
          <ServicesSection onRequestAudit={openRequestForm} />
        </Suspense>
        <Suspense fallback={<SectionFallback />}>
          <MethodologySection />
        </Suspense>
        <Suspense fallback={<SectionFallback />}>
          <FAQSection />
        </Suspense>
        <Suspense fallback={<SectionFallback />}>
          <ContactSection />
        </Suspense>
      </main>
      <Suspense fallback={null}>
        <Footer />
      </Suspense>
      <RequestFormDialog open={formOpen} onOpenChange={setFormOpen} />
    </div>
  );
};

export default Security;
